<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import { mapState } from 'vuex'
  import EditProfileImageOverlay from '@/components/overlays/EditProfileImageOverlay'

  export default {
    name: 'EditGroupOverlay',
    components: {
      EditProfileImageOverlay,
    },
    props: {
      isOpen: Boolean,
      group: Object,
    },
    data() {
      return {
        description: '',
        name: '',
        groupImage: '',
        newImage: '',
        overlayEditProfile: false,
        overlayUpload: false,
        imageUploaderConfig: {
          // Should add file config properties here which different from FileUploader's baseConfig settings
        },
      }
    },
    computed: {
      ...mapState('auth', ['settings']),
      opened: {
        set() {
          this.$emit('onCloseOverlay')
        },
        get() {
          return this.isOpen
        },
      },
    },
    created() {
      this.description = this.group.infos.description
      this.name = this.group.infos.title
      this.groupImage = this.group.infos.img
    },
    methods: {
      onSubmit() {
        this.$emit('submit', { description: this.description, name: this.name }, this.newImage)
      },
      setOverlayUpload(value) {
        this.overlayUpload = value
      },
      setOverlayEditProfile(value) {
        this.overlayEditProfile = value
      },
      onSetNewImage(image) {
        this.newImage = image
      },
      onSaveImage(image) {
        this.groupImage = image.url
      },
    },
  }
</script>
